import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-400 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-white font-bold text-lg mb-3">
              Smart Resource Hub
            </h3>
            <p className="text-sm text-gray-400 mb-4">
              Staff augmentation and resource management platform by Guru Group
              LLC. Connect with top technical talent instantly.
            </p>
            <a
              href="mailto:resourcehub@gurug.com"
              className="text-primary-500 hover:text-primary-600 text-sm transition-colors"
            >
              resourcehub@gurug.com
            </a>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-3">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              {[
                { to: "/resources", label: "Resource Directory" },
                { to: "/skill-matrix", label: "Skill Matrix" },
                // { to: "/rate-card", label: "Rate Card" },
                { to: "/about", label: "About Us" },
                { to: "/contact", label: "Contact" },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-3">Services</h4>
            <ul className="space-y-2 text-sm">
              <li>Staff Augmentation</li>
              <li>Technical Consulting</li>
              <li>Solution Architecture</li>
              <li>Pre-sales Support</li>
              <li>Workforce Planning</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-sm">
          <p>
            © {currentYear} Guru Group LLC. All rights reserved. Smart Resource
            Hub.
          </p>
        </div>
      </div>
    </footer>
  );
}
